import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BOMRepository from "src/repository/Admin/AdminBOMRepository";

export const getBomList = createAsyncThunk('get_bom_list', async (params) => {
    const data = await new BOMRepository().getBOMListAdmin(params);
    return data;
});

const slice = createSlice({
    name: "adminBom",
    initialState: {
        bomList: [],
        message:''
    },
    reducers: {
        setBomList: {
            reducer: (state, action) => {
                state.bomList = [action.payload];
                return state;
            },
        },
        setMessage: {
            reducer: (state, action) => {
                state.message = action.payload;
                return state;
            },
        },
    },
    extraReducers: {
        [getBomList.fulfilled]: (state, action) => {
            state.bomList = [action.payload];
        },
        [getBomList.rejected]: (state, action) => {
            state.bomList = [];
            state.message="Sorry! We can't find any results based on your selection."
            
        },
    },
});



export let { setBomList,setMessage } = slice.actions;

export default slice.reducer;
